import { memo, useState } from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import dynamic from 'next/dynamic';
import dayjs from 'dayjs';
import { IContent } from 'src/interface';
import { formatTime } from 'src/utils/date';
import { isOpenSelector } from 'src/selectors/content';
import { Element, RouterLink } from 'src/components';
import { ContentPublisher } from 'src/modules/content/components/shared/ContentPublisher';
import { ContentMoreAction } from '../ContentAction/more';
import styles from './style.module.scss';

const AudioSpeech = dynamic(() => import('../AudioSpeech'), {
    ssr: false,
});

interface IProps {
    content: IContent;
}

const ContentMeta = ({ content = {} as IContent }: IProps) => {
    const { publishedDate, publisher, speechs } = content;
    const isOpen = useSelector(isOpenSelector);
    const [isPlaying, setPlaying] = useState<boolean>(false);

    return (
        <Element
            className={cn(
                styles['content-meta'],
                'flex items-center',
                'mb-[12px]',
                'text-[13px] leading-[1] text-[#666666]',
                'font-semibold',
                'whitespace-nowrap',
                {
                    '[&>*:not(:last-child)]:!mr-[12px]': !isOpen,
                },
            )}
        >
            {publisher && !isOpen && (
                <RouterLink to={publisher.url}>
                    <ContentPublisher
                        publisher={publisher}
                        hStyle={24}
                        mhStyle={16}
                        lazyloadImage={false}
                    />
                </RouterLink>
            )}
            {publishedDate && (
                <Element
                    renderAs="time"
                    dateTime={dayjs(publishedDate * 1000).toISOString()}
                >
                    {formatTime(publishedDate)}
                </Element>
            )}
            <RouterLink to={content.redirectUrl} newTab={true}>
                <Element renderAs="span">{isOpen ? 'Bài gốc' : 'Gốc'}</Element>
            </RouterLink>
            <Element
                className={cn({
                    ['ml-auto']: !isOpen,
                })}
            >
                {speechs?.length && (
                    <AudioSpeech
                        speechs={speechs}
                        setPlaying={setPlaying}
                        isPlaying={isPlaying}
                    />
                )}

                {!isOpen && <ContentMoreAction {...content} />}
            </Element>
        </Element>
    );
};

export default memo(ContentMeta);
